var _path, _rect, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmallMessage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 17.5V7.6C6.5 7.2975 6.60771 7.03854 6.82313 6.82313C7.03854 6.60771 7.2975 6.5 7.6 6.5H16.4C16.7025 6.5 16.9615 6.60771 17.1769 6.82313C17.3923 7.03854 17.5 7.2975 17.5 7.6V14.2C17.5 14.5025 17.3923 14.7615 17.1769 14.9769C16.9615 15.1923 16.7025 15.3 16.4 15.3H8.7L6.5 17.5ZM8.2325 14.2H16.4V7.6H7.6V14.8188L8.2325 14.2Z",
    fill: "#8790A1"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 9,
    width: 6,
    height: 1,
    rx: 0.5,
    fill: "#8790A1"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 11,
    width: 3,
    height: 1,
    rx: 0.5,
    fill: "#8790A1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallMessage);
export default __webpack_public_path__ + "static/media/SmallMessage.5f1f403eda882cbab2c05792b227f07c.svg";
export { ForwardRef as ReactComponent };